export default __webpack_public_path__ + "static/media/imgvoucher2.f8a27a21.png";